import { getBackendBaseUrl } from "./backendDiscovery";

/**
 * Executa uma consulta GraphQL generica
 * @param {string} query - A consulta GraphQL
 * @param {Object} variables - As variaveis da consulta
 * @returns {Promise<any>} - O resultado da consulta
 */
export const graphqlRequest = async (query, variables = {}) => {
  try {
    const backendBaseUrl =
      process.env.REACT_APP_GRAPHQL_ENDPOINT?.replace(/\/graphql$/, "") ||
      (await getBackendBaseUrl());

    const response = await fetch(`${backendBaseUrl}/graphql`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ query, variables }),
    });

    const result = await response.json();

    if (result.errors) {
      console.error("Erro na resposta GraphQL:", result.errors);
      throw new Error("Erro na requisicao GraphQL");
    }

    return result.data;
  } catch (error) {
    console.error("Erro ao fazer requisicao GraphQL:", error);
    throw error;
  }
};
